// extracted by mini-css-extract-plugin
export var auto = "_3p-1";
export var spinner = "_3p-0";